/* rhoneprints: little messages that float up for a few seconds. click one and it crumbles away. pop 5 of them and the screen fills with messages that pop up all over and slowly fade out, then the count starts over. */
/* rhoneprints: on mobile this whole poppable-message feature is skipped -- only the background falling-digits layer (rain.js) shows there. */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MSGS = [
    'you look pretty today :)', 'try to find the golden cat', 'i wonder what the golden numbers do',
    'your eyes look nice', 'where am i', 'i love cats', 'hope your day is good',
    'i wonder what you will buy?', 'feel free to look around', 'welcome in!', "i'm so warm",
    "don't feel pressured to buy anything", "i'm so hungry", 'which one is your favorite?',
    'write me a review!', 'leave me a comment', 'i wish it would stop raining',
    'sometimes i get lonely', 'i like your smile', 'that shirt is dope!', "what's your favorite song?",
    'click me!',
    "you're not alone :)", 'i care about you', 'i miss you', 'i hope you remember me',
    'you are special', 'you mean something to this world'
  ];
  var OPEN_COMMENT = { 'write me a review!': 1, 'leave me a comment': 1 };
  var EDGE = ['#22e6ff', '#ff2fd0', '#ffe94a', '#f2efff'];
  var deck = [], current = null;

  /* tally of popped messages (kept across visits, starts over after every celebration) */
  var GOAL = 5, KEY = 'gl-msgs';
  var count = 0, celebrating = false, tally = null;
  try {
    count = parseInt(localStorage.getItem(KEY) || '0', 10) || 0;
    if (count >= GOAL) count = 0;
  } catch (e) {}

  var st = document.createElement('style');
  st.textContent =
    '.gl-whisper{position:fixed;z-index:10000;box-sizing:border-box;max-width:24rem;margin:0;padding:.9rem 1.3rem;font:inherit;font-size:1.5rem;line-height:1.3;letter-spacing:.06em;text-align:left;text-transform:lowercase;color:#f2efff;background:rgba(10,10,16,.9);border:1px solid var(--gl-w,#22e6ff);cursor:pointer;text-shadow:-1px 0 rgba(34,230,255,.8),1px 0 rgba(255,47,208,.8);animation:gl-w-in .3s steps(4) both;-webkit-tap-highlight-color:transparent}' +
    '.gl-whisper:hover,.gl-whisper:focus-visible{box-shadow:-2px 0 0 #22e6ff,2px 0 0 #ff2fd0;outline:none}' +
    '.gl-whisper.is-out{animation:gl-w-out .6s ease forwards}' +
    '.gl-whisper.is-gone{visibility:hidden}' +
    '@keyframes gl-w-in{0%{opacity:0;transform:translateY(1rem)}40%{opacity:1;transform:translate(-4px,0)}60%{transform:translate(3px,0)}100%{opacity:1;transform:none}}' +
    '@keyframes gl-w-out{to{opacity:0;transform:translateY(-.8rem)}}' +
    '.gl-bit{position:fixed;z-index:10000;pointer-events:none;will-change:transform,opacity}' +
    '.gl-mtally{position:fixed;left:14px;bottom:58px;z-index:9999;padding:.6rem 1rem;font:inherit;font-size:1.2rem;letter-spacing:.14em;text-transform:lowercase;color:#f2efff;background:rgba(10,10,16,.85);border:1px solid rgba(255,47,208,.75);pointer-events:none}' +
    '.gl-mtally.is-bump{animation:gl-mtally-bump .4s steps(4)}' +
    '.gl-mtally.is-done{border-color:#ffd23f;color:#ffd23f}' +
    '@keyframes gl-mtally-bump{0%{transform:translate(-3px,0)}50%{transform:translate(3px,0);box-shadow:-2px 0 0 #22e6ff,2px 0 0 #ff2fd0}100%{transform:none}}' +
    '.gl-mfall{position:fixed;z-index:10000;pointer-events:none;white-space:nowrap;font:inherit;line-height:1.2;letter-spacing:.06em;text-transform:lowercase;color:var(--gl-c,#f2efff);text-shadow:0 0 .6rem var(--gl-c,#f2efff);animation:gl-mpop var(--gl-d,8s) ease-out both;will-change:transform,opacity}' +
    '@keyframes gl-mpop{0%{opacity:0;transform:scale(.6)}4%{opacity:1;transform:translate(-4px,0) scale(1.1)}8%{transform:translate(3px,0) scale(.97)}12%{opacity:1;transform:none}55%{opacity:1;transform:none}100%{opacity:0;transform:translateY(-1rem)}}' +
    '.gl-mwin{position:fixed;left:50%;top:22%;z-index:10001;transform:translateX(-50%);padding:1.2rem 2rem;font:inherit;font-size:1.8rem;letter-spacing:.14em;text-transform:lowercase;text-align:center;color:#f2efff;background:rgba(10,10,16,.94);border:1px solid #ffd23f;box-shadow:0 0 2.4rem rgba(255,210,63,.3);pointer-events:none;animation:gl-mwin 4.2s ease forwards}' +
    '@keyframes gl-mwin{0%{opacity:0;transform:translate(-50%,1rem)}10%,80%{opacity:1;transform:translate(-50%,0)}100%{opacity:0;transform:translate(-50%,-.6rem)}}' +
    'body.gl-zoomed .gl-mfall,body.gl-zoomed .gl-mtally,body.gl-zoomed .gl-mwin{display:none!important}' +
    '@media screen and (max-width:749px){.gl-whisper{font-size:1.3rem;max-width:20rem}.gl-mtally{bottom:14px}.gl-mwin{width:78vw;box-sizing:border-box}}';
  document.head.appendChild(st);

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function nextMsg() {
    if (!deck.length) {
      deck = MSGS.slice();
      for (var i = deck.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = deck[i]; deck[i] = deck[j]; deck[j] = t; }
    }
    return deck.pop();
  }
  function busy() {
    if (document.hidden || current || celebrating) return true;
    if (document.querySelector('.gl-gpop')) return true;
    var a = document.activeElement;
    if (a && /^(input|textarea|select)$/i.test(a.tagName)) return true;
    return false;
  }

  /* ---------- tally ---------- */
  /* sits just above the numbers-popped tally when that one is showing */
  function tallyPos() {
    if (!tally) return;
    var other = document.querySelector('.gl-tally');
    var base = window.innerWidth >= 750 ? 58 : 14;
    tally.style.bottom = (base + (other ? 44 : 0)) + 'px';
  }
  function paintTally(bump) {
    if (count < 1) return;
    if (!tally) {
      tally = document.createElement('div');
      tally.className = 'gl-mtally';
      tally.setAttribute('data-gl-skip', '');
      tally.setAttribute('role', 'status');
      document.body.appendChild(tally);
    }
    tally.textContent = 'messages popped ' + count + '/' + GOAL;
    tally.classList.toggle('is-done', count >= GOAL);
    tallyPos();
    if (bump) { tally.classList.remove('is-bump'); void tally.offsetWidth; tally.classList.add('is-bump'); }
  }
  setInterval(tallyPos, 1000);
  if (document.body) paintTally(false); else document.addEventListener('DOMContentLoaded', function () { paintTally(false); });

  /* 5/5: a crowd of messages pops up all over the screen, stays a moment, then slowly fades away */
  function celebrate() {
    var win = document.createElement('div');
    win.className = 'gl-mwin';
    win.setAttribute('data-gl-skip', '');
    win.textContent = 'Good job!';
    document.body.appendChild(win);
    setTimeout(function () { if (win.parentNode) win.parentNode.removeChild(win); }, 4400);
    if (window.glSfx && window.glSfx.kaching) window.glSfx.kaching();
    if (reduce) return;
    if (window.__glZoomed && window.__glZoomed()) return;
    var palette = ['#22e6ff', '#ff2fd0', '#f2efff', '#ffe94a', '#22e6ff', '#ff2fd0'];
    var vw = window.innerWidth, vh = window.innerHeight, wide = vw >= 750;
    var total = wide ? 46 : 26;
    var pool = [];
    for (var i = 0; i < total; i++) {
      (function (k) {
        setTimeout(function () {
          if (!document.body) return;
          if (!pool.length) { pool = MSGS.slice(); for (var a = pool.length - 1; a > 0; a--) { var b = Math.floor(Math.random() * (a + 1)), t = pool[a]; pool[a] = pool[b]; pool[b] = t; } }
          var d = document.createElement('span');
          d.className = 'gl-mfall';
          d.setAttribute('aria-hidden', 'true');
          d.textContent = pool.pop();
          d.style.left = (wide ? rnd(1, vw - 280) : rnd(2, vw * 0.4)) + 'px';
          d.style.top = Math.round(rnd(0.1, 0.9) * vh) + 'px';
          d.style.fontSize = rnd(wide ? 13 : 11, wide ? 24 : 17) + 'px';
          d.style.setProperty('--gl-c', palette[Math.floor(Math.random() * palette.length)]);
          d.style.setProperty('--gl-d', rnd(6, 9) + 's');
          d.addEventListener('animationend', function () { if (d.parentNode) d.parentNode.removeChild(d); });
          document.body.appendChild(d);
        }, rnd(0, 3200));
      })(i);
    }
  }
  function resetTally() {
    count = 0;
    celebrating = false;
    try { localStorage.setItem(KEY, '0'); } catch (e) {}
    if (tally && tally.parentNode) tally.parentNode.removeChild(tally);
    tally = null;
  }
  function popped() {
    if (celebrating) return;
    count = Math.min(GOAL, count + 1);
    try { localStorage.setItem(KEY, String(count)); } catch (e) {}
    paintTally(true);
    if (count >= GOAL) {
      celebrating = true;
      setTimeout(celebrate, 600);
      /* once the messages have faded, the tally starts over */
      setTimeout(resetTally, 14000);
    }
  }
  window.__glMsgPopped = function () { return count; };

  function crumble(el, text) {
    var r = el.getBoundingClientRect();
    el.classList.add('is-gone');
    if (window.glSfx && window.glSfx.crumble) window.glSfx.crumble();
    if (reduce || !el.animate) return;
    var cs = getComputedStyle(el);
    var size = window.innerWidth < 750 ? 5 : 6;
    var cols = Math.max(2, Math.round(r.width / size)), rows = Math.max(2, Math.round(r.height / size));
    var palette = ['#f2efff', '#22e6ff', '#ff2fd0', el.style.getPropertyValue('--gl-w') || '#22e6ff', '#0a0a10'];
    var frag = document.createDocumentFragment(), bits = [];
    for (var y = 0; y < rows; y++) {
      for (var x = 0; x < cols; x++) {
        if (Math.random() < 0.28) continue;
        var b = document.createElement('i');
        b.className = 'gl-bit';
        b.style.cssText = 'left:' + (r.left + x * size) + 'px;top:' + (r.top + y * size) + 'px;width:' + size + 'px;height:' + size + 'px;background:' + palette[Math.floor(Math.random() * palette.length)];
        frag.appendChild(b);
        var delay = (x / cols) * 380 + Math.random() * 120;
        b.animate([
          { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
          { transform: 'translate(' + rnd(10, 90) + 'px,' + rnd(-50, 40) + 'px) rotate(' + rnd(-200, 200) + 'deg)', opacity: 0 }
        ], { duration: rnd(600, 1000), delay: delay, easing: 'cubic-bezier(.2,.6,.4,1)', fill: 'both' });
        bits.push(b);
      }
    }
    document.body.appendChild(frag);
    setTimeout(function () { bits.forEach(function (b) { if (b.parentNode) b.parentNode.removeChild(b); }); }, 1700);
  }

  function place(el) {
    var vw = window.innerWidth, vh = window.innerHeight, wide = vw >= 750;
    var w = el.offsetWidth, h = el.offsetHeight;
    var minL = wide ? 340 : 12, maxL = Math.max(minL, vw - w - (wide ? 300 : 12));
    var minT = Math.max(120, vh * 0.2), maxT = Math.max(minT, vh * (wide ? 0.72 : 0.6) - h);
    el.style.left = rnd(minL, maxL) + 'px';
    el.style.top = rnd(minT, maxT) + 'px';
  }

  function show() {
    if (busy() || !document.body) return false;
    var text = nextMsg();
    var el = document.createElement('button');
    el.type = 'button';
    el.className = 'gl-whisper';
    el.setAttribute('data-gl-skip', '');
    el.style.setProperty('--gl-w', EDGE[Math.floor(Math.random() * EDGE.length)]);
    el.textContent = text;
    el.style.visibility = 'hidden';
    document.body.appendChild(el);
    place(el);
    el.style.visibility = '';
    current = el;
    var done = false;
    var finish = function () {
      if (done) return; done = true;
      clearTimeout(t1);
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); if (current === el) current = null; }, 700);
    };
    var t1 = setTimeout(function () { el.classList.add('is-out'); finish(); }, rnd(5000, 7000));
    el.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (done) return;
      crumble(el, text);
      finish();
      popped();
      if (OPEN_COMMENT[text]) {
        setTimeout(function () {
          var bar = document.querySelector('[data-cm-open]');
          if (bar && bar.getAttribute('aria-expanded') !== 'true') bar.click();
        }, 500);
      }
    });
    return true;
  }

  function loop(first) {
    setTimeout(function () {
      show();
      loop(false);
    }, first ? 14000 : rnd(26000, 48000));
  }
  loop(true);
  window.__glWhisper = show;
})();